
import LoadSimple from "../../LoadSimple";
import Modal from 'react-modal';
import ModalDeleteBrand from "./ModalDeleteBrand";
import { useState, useEffect } from "react";
import { capitalizeFirstLetter } from "../../../utils/utils";
import { lang } from "../../generales/traduction";
import "./styles/WFstyles.css"
import ModalMsgError from "./ModalMsgError";
import ModalHostList from "./ModalHostLis";
import ModalHostListSync from "./ModalHostListSync";
import { permisos_codigo_id } from "../../generales/GroupsId";
const deleteUserModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    height: '20%',
    padding: '20px'
  },
};
const hostListModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "90%",
    padding: "20px",
  },
};
const hostListModalSyncStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    height: "90%",
    padding: "20px",
  },
};
const msgErrorModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    height: '40%',
    padding: '20px'
  },
};
const statusWF = {
  '-1': 'var(--hover-color)',
  '0': 'var(--yellow-low)',
  '1': 'var(--green-pastel)',
  '2': 'var(--error-color)'
}
const WorkFlowList = ({
  pageActual,
  limitList, startLimit,
  dataList,
  devices,
  handleChangEdit,
  setData,
  setRegisterIsValid,
  setLoading,
  setError,
  server,
  dataUsers,
  setDataUsers,
  searchResults,
  setSearchResults,
  searchTerm,
  setSearchTerm,
  cisSelected,
  setCisSelected,
  languaje,
  mode,
  rowSelected,
  poolRows,
  handleShowPopup,
  buscar_cis,
  loadingList, userPermissions
}) => {
  const [deleteUserModalOpen, setDeleteUserModalOpen] = useState(false);
  const [msgErrorModalOpen, setMsgErrorModalOpen] = useState(false);
  const [userSelected, setUserSelected] = useState({})
  const [hostsListModalOpen, setHostsListModalOpen] = useState(false);
  const [hostsListSyncModalOpen, setHostsListSyncModalOpen] = useState(false);
  function openDeleteUserModal() {
    setDeleteUserModalOpen(true);
  }

  function closDeleteUserModal() {
    setSearchTerm("")
    setDeleteUserModalOpen(false);
  }
  function openMsgErrorModal() {
    setMsgErrorModalOpen(true);
  }

  function closMsgErrorModal() {

    setMsgErrorModalOpen(false);
  }
  function openHostsListModal() {
    setHostsListModalOpen(true);
  }

  function closHostsListModal() {

    setHostsListModalOpen(false);
  }
  function openHostsListSyncModal() {
    setHostsListSyncModalOpen(true);
  }

  function closHostsListSyncModal() {

    setHostsListSyncModalOpen(false);
  }
  const [source, setSource] = useState('')
  const handleHostLisClick = (data, source) => {

    openHostsListModal()
    setUserSelected(data)
    setSource(source)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  const handleHostLisSyncClick = (data, source) => {

    openHostsListSyncModal()
    setUserSelected(data)
    setSource(source)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  const handledeleteUserClick = (data) => {

    openDeleteUserModal()
    setUserSelected(data)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  const handleMsgErrorClick = (data) => {

    openMsgErrorModal()
    setUserSelected(data)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  const cisSelectRow = (elemento) => {
    setCisSelected(elemento);
  };
  return (
    <>
      <div className="cont-row-user-list">
        {loadingList ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          dataList
            .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
            .map((elemento, indice) => (
              <div
                className={"row-table-portafolio" + mode}
                key={indice}
                style={{ height: '45px' }}
              >

                <div className="field-body-table-mantenimiento field-small">
                  {elemento.id}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{ width: '15%' }} >
                  {elemento.name}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{ width: '15%' }} >
                  {elemento.description}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{ width: '20%' }} >
                  {(elemento.hostid == null) ? elemento.group_name : elemento.hostname}
                </div>
                <div className="field-body-table-mantenimiento field-larger"  >
                  {elemento.metric_name}
                </div>
                <div className="field-body-table-mantenimiento field-larger" >
                  {elemento.trigger_name}
                </div>
                <div className="field-body-table-mantenimiento field-larger"  >
                  {elemento.event_name}
                </div>
                <div className="field-body-table-mantenimiento field-medium" >
                  {(elemento.ticket_auto == 0) ? capitalizeFirstLetter(lang[languaje]['no']) : capitalizeFirstLetter(lang[languaje]['si'])}
                </div>
                <div className="field-body-table-mantenimiento field-larger fieldWFstatus"  >
                  {
                    (elemento.status_value == 2) ?
                      <div style={{ width: '25%' }} className="infoWFerror">
                        <img
                          src={
                            "/iconos/info.png"
                          }
                          onClick={() => handleMsgErrorClick(elemento)}
                          name="info" title='info' className="btnAction delteException" style={{ width: '65%' }}
                        />
                      </div> : ''
                  }

                  {/* <div className="tagIpAvailable" style={{color:(elemento.status_value==0 || elemento.status_value==undefined)?'var(--txt-color)':'var(--white-color)',background:(elemento.status_value==0 || elemento.status_value==undefined)?'var(--hover-color)':(elemento.status_value==1)?'var(--green-pastel)':'var(--error-color)'}}> */}
                  <div className="tagIpAvailable" style={{ color: (elemento.status_value == 0 || elemento.status_value == undefined || elemento.status_value == -1) ? 'var(--txt-color)' : 'var(--white-color)', background: (elemento.status_sincronizacion == null) ? statusWF[elemento.status_value] : '#13ccff' }}>
                    {(elemento.status_sincronizacion == null) ? elemento.status_text : 'Sincronizando'}
                  </div>

                </div>
                <div className="field-body-table-mantenimiento field-medium fieldWFstatus" >
                  {

                    <div style={{ width: '45%' }} className="infoWFerror">
                      <img
                        src={
                          "/iconos/review.png"
                        }
                        onClick={() => handleHostLisClick(elemento, 'byGroupID')}
                        name="ver" title='ver' className="btnAction delteException" style={{ width: '65%' }}
                      />
                    </div>
                  }
                  {elemento.group_count}
                </div>
                <div className="field-body-table-mantenimiento field-medium fieldWFstatus" >
                  {

                    <div style={{ width: '45%' }} className="infoWFerror">
                      <img
                        src={
                          "/iconos/review.png"
                        }
                        onClick={() => handleHostLisClick(elemento, 'byTemplateID')}
                        name="Ver" title='Ver' className="btnAction delteException" style={{ width: '65%' }}
                      />
                    </div>
                  }
                  {elemento.template_count}
                </div>
                {/* <div className="field-body-table-mantenimiento field-medium">
                  {

                    <>

                      {(elemento.group_count != elemento.template_count && elemento.hostid == null) ?
                        <div style={{ width: '33%' }}>
                          <img
                            src={
                              "/iconos/sync.png"
                            }
                            onClick={() => handleHostLisSyncClick(elemento)}
                            name="sync" title='sync' className="btnAction delteException" style={{ width: '65%' }}
                          />
                        </div> : ''}
                      {userPermissions.some(
                        (objeto) => objeto.permission_id === permisos_codigo_id["crear workflow"]
                      ) ? <div style={{ width: '33%' }}>
                        <img
                          src={
                            "/iconos/delete.png"
                          }
                          onClick={() => handledeleteUserClick(elemento)}
                          name="Eliminar" title='Eliminar' className="btnAction delteException" style={{ width: '65%' }}
                        />
                      </div> : ''}
                    </>
                  }

                </div> */}
              </div>
            ))
        )}
        {dataList.length == 0 ? (
          <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
        ) : (
          ""
        )}
      </div>
      <Modal
        isOpen={deleteUserModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closDeleteUserModal}
        style={deleteUserModalStyles}
        contentLabel="Example Modal2"
      // shouldCloseOnOverlayClick={false}
      >
        <ModalDeleteBrand handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} buscar_cis={buscar_cis} server={server} setData={setData} setLoading={setLoading} setError={setError} user={userSelected} closDeleteUserModal={closDeleteUserModal}></ModalDeleteBrand>
      </Modal>
      <Modal
        isOpen={msgErrorModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closMsgErrorModal}
        style={msgErrorModalStyles}
        contentLabel="Example Modal2"
      // shouldCloseOnOverlayClick={false}
      >
        <ModalMsgError languaje={languaje} user={userSelected} closDeleteUserModal={closMsgErrorModal}></ModalMsgError>
      </Modal>
      <Modal
        isOpen={hostsListModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closHostsListModal}
        style={hostListModalStyles}
        contentLabel="Example Modal2"
      // shouldCloseOnOverlayClick={false}
      >
        <ModalHostList source={source} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} buscar_cis={buscar_cis} server={server} setData={setData} setLoading={setLoading} setError={setError} brand={userSelected} closHostsListModal={closHostsListModal}></ModalHostList>
      </Modal>
      <Modal
        isOpen={hostsListSyncModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closHostsListSyncModal}
        style={hostListModalSyncStyles}
        contentLabel="Example Modal2"
      // shouldCloseOnOverlayClick={false}
      >
        <ModalHostListSync source={source} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} buscar_cis={buscar_cis} server={server} setData={setData} setLoading={setLoading} setError={setError} brand={userSelected} closHostsListModal={closHostsListSyncModal}></ModalHostListSync>
      </Modal>
    </>
  );
};

export default WorkFlowList;
